(ns common.widgets.tab-navigation
  (:require ["@mui/material/Tab$default" :as Tab]
            ["@mui/material/Tabs$default" :as Tabs]
            [reitit.frontend.easy :as rfe]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui tab-navigation
  [{:keys [tabs sx]}]
  (let [active-tab (use-subscribe [:router/fragment])
        active-tab (or active-tab
                       (first (keys tabs)))
        current-route (use-subscribe [:router/current-route])
        required-permissions (->> (vals tabs)
                                  (keep :permission)
                                  set)
        permission->allowed (use-subscribe [:resource.user/permission->allowed? required-permissions])]
    ($ Tabs
       {:value (name active-tab)
        :sx sx}
       (for [[k {:keys [on-click permission label]}] tabs
             :when (get permission->allowed permission true)]
         ($ Tab
            {:value (name k)
             :key k
             :href (rfe/href (:name (:data current-route))
                             (:path (:parameters current-route))
                             (:query (:parameters current-route))
                             (name k))
             :onClick (fn [e]
                        (when on-click
                          (on-click e)))
             :data-testid (str "tab-" (name k))
             :label label})))))
